import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bb388562&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bb388562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb388562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb388562')) {
      api.createRecord('bb388562', component.options)
    } else {
      api.reload('bb388562', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bb388562&scoped=true&", function () {
      api.rerender('bb388562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W6Tle6s5Zzth/JS/comp/SearchFilterTokens.vue"
export default component.exports